import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from "react-router-dom";
import { useI18N } from '../../context/I18NContext';
import { useTheme } from '@mui/material';
function createData(datetime, name) {
    return { datetime, name };
}
const rows = [
    createData('26 mei 2025 om 10:30', 'Boksen'),
    createData('31 mei 2025 om 14:30', 'Kick-boxing')
];
export default function AppointmentList(props) {
    const navigate = useNavigate();
    const { t } = useI18N();
    const theme = useTheme();
    const goTo = (e) => {
        let target = e.target.closest('button');
        if (!target) {
            target = e.target.closest('li');
        }
        let path = target.getAttribute('rel');
        navigate(`/${path}`);
    };
    return (_jsx(_Fragment, { children: _jsx(TableContainer, { component: Paper, sx: {
                backgroundColor: theme.palette.background.default
            }, children: _jsx(Table, { sx: {
                    width: '100%',
                    marginBottom: 2,
                }, "aria-label": "simple table", children: _jsx(TableBody, { children: rows.map((row) => (_jsxs(TableRow, { sx: { '&:last-child td, &:last-child th': { border: 0 } }, children: [_jsxs(TableCell, { component: "th", scope: "row", children: [row.name, _jsx("br", {}), row.datetime] }), _jsx(TableCell, { align: "right", children: props.type === 'future' && (_jsxs(_Fragment, { children: [_jsx(Button, { onClick: goTo, rel: 'oa_widget_reschedule', variant: "contained", sx: { marginBottom: 1 }, children: t('Verzetten') }), _jsx("br", {}), _jsx(Button, { onClick: goTo, rel: 'oa_widget_cancel', variant: "contained", children: t('Annuleren') })] })) })] }, row.name))) }) }) }) }));
}
